import { NewPassword } from './new-password';

export default function NewPasswordPage() {
  return <NewPassword />;
}
